import React from 'react';

// A single KPI tile: colored left accent bar, icon chip, label, big value, sub line.
const KpiTile = ({ icon: Icon, label, value, sub, subTone = 'muted', accent = '#6d28d9', iconBg = '#ede9fe' }) => {
  const toneClass = subTone === 'up' ? 'text-green-600' : subTone === 'down' ? 'text-red-600' : 'text-slate-400';
  return (
    <div className="relative bg-white rounded-xl border p-4 overflow-hidden" style={{ borderColor: '#eef1f6' }}>
      <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: accent }} />
      <div className="flex items-center gap-2 text-[11px] text-slate-500 font-jakarta">
        {Icon && (
          <span className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0" style={{ background: iconBg }}>
            <Icon className="w-4 h-4" style={{ color: accent }} />
          </span>
        )}
        <span>{label}</span>
      </div>
      <div className="text-2xl font-outfit font-bold text-slate-900 mt-1.5">{value}</div>
      {sub != null && <div className={`text-[11px] mt-0.5 font-jakarta ${toneClass}`}>{sub}</div>}
    </div>
  );
};

export default KpiTile;
